// PasswordResetForm.js
import React, { useState } from "react";
import OtpVerificationForm from "./OtpVerificationForm";
import PhoneInput from "react-phone-input-2";
import axios from "axios";
import { message } from "antd";
import "react-phone-input-2/lib/style.css";
import "./PasswordResetForm.css";

const PasswordResetForm = ({ role }) => {
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [isLoading, setIsLoading] = useState(false);


  const handlePhoneNumberSubmit = async (e) => {
    e.preventDefault();


    // Validate phone number format
    if (
      !phone.startsWith("251") &&
      !phone.startsWith("09") &&
      !phone.startsWith("07")
    ) {
      setPhoneError("Invalid Phone number");
      return;
    } else if (phone.startsWith("251") && phone.length !== 12) {
      setPhoneError("Invalid Phone number");
      return;
    } else if (
      (phone.startsWith("09") || phone.startsWith("07")) &&
      phone.length !== 10
    ) {
      setPhoneError("Invalid Phone number");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.post("/send-password-reset-otp", {
        phone: phone.startsWith("251") ? phone : `251${phone.substring(1)}`,
      });

      if (response.data.status === "success") {
         
        message.success("OTP sent successfully");
        setShowOtpForm(true);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        message.error("No user found with this phone number");
      } else {
        message.error(error.response?.data?.message || "Failed to send OTP");
      }
    }
    finally {
      setIsLoading(false);
    }
  };

  const handlePhoneChange = (value) => {
    setPhoneError("");
    setPhone(value);
  };

  if (showOtpForm) {
    return <OtpVerificationForm phoneNumber={phone} role={role} />;
  }

  return (
    <div className="password-reset-wrapper">
      <div className="password-reset-container">
        <div className="password-reset-header">
          <h2>Forgot Password?</h2>
          <p>No worries, we'll send you OTP to reset</p>
        </div>
        <form onSubmit={handlePhoneNumberSubmit}>
          <div className="phone-input-container">
            <PhoneInput
              country={"et"}
              value={phone}
              onChange={handlePhoneChange}
              enableAreaCodes={true}
              countryOptions={{
                showFlags: true,
              }}
              containerClass="phone-input-container"

            />
             

            {phoneError && <div className="error-message">{phoneError}</div>}
          </div>

          {isLoading ? (
          <>
            <div className="loading-spinner" />
            <button type="button" className="submit-button">
            Sending...
            </button>
          </>
        ) : (
          <>
            <button type="submit" className="submit-button">
              Send OTP
            </button>
          </>
          )}
        </form>
      </div>
    </div>
  );
};

export default PasswordResetForm;